export default __webpack_public_path__ + "static/media/thumb2.b870d308.png";